import React from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { MsalProvider } from "@azure/msal-react";
import ErrorProvider from "context/ErrorHandlingContext";
import { store } from "state/store";

import ErrorFallBack from "components/ErrorFallBack/ErrorFallBack";

import RequestClickTrigger from "./context/RequestClickTrigger";
import App from "./App";
import { msalInstance } from "./msalInstance";

// Re-exported so existing importers of msalInstance from "index" keep working.
export { msalInstance };

const container = document.querySelector("#root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

root.render(
  <>
    <ErrorBoundary FallbackComponent={ErrorFallBack}>
      <Provider store={store}>
        <RequestClickTrigger>
          <ErrorProvider>
            <App msalInstance={msalInstance} />
          </ErrorProvider>
        </RequestClickTrigger>
      </Provider>
    </ErrorBoundary>
  </>
);
